// extracted by mini-css-extract-plugin
export default {"textField":"SingleRatingAnswer_textField__OSr6M"};